// Estilos globales del juego
export const styles = {
  page: {
    minHeight: "100vh",
    background: "radial-gradient(circle at top, #10233d 0, #0a0f1f 60%, #000814 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 12,
    color: "#E8F6FF",
    fontFamily: "system-ui, sans-serif",
  },
  card: {
    background: "rgba(0,0,0,0.85)",
    borderRadius: 12,
    border: "1px solid rgba(0, 155, 255, 0.45)",
    boxShadow: "0 0 20px rgba(0, 155, 255, 0.35)",
    padding: 16,
    maxWidth: 540,
    width: "100%",
  },
  title: {
    margin: "0 0 4px",
    fontSize: "1.2rem",
    color: "#5DB6FF",
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    textAlign: "center",
  },
  subtitle: {
    fontSize: 12,
    textAlign: "center",
    color: "#A8D5FF",
    marginBottom: 10,
  },
  label: {
    fontSize: 12,
    marginBottom: 3,
  },
  input: {
    width: "100%",
    padding: "6px 8px",
    borderRadius: 8,
    border: "1px solid rgba(0, 155, 255, 0.35)",
    background: "#020b16",
    color: "#E8F6FF",
    fontSize: 13,
    boxSizing: "border-box",
    marginBottom: 4,
  },
  button: {
    marginTop: 6,
    width: "100%",
    background: "linear-gradient(135deg, #0077CC, #0099FF)",
    borderRadius: 999,
    border: "none",
    padding: "8px 12px",
    fontSize: 14,
    fontWeight: 600,
    color: "#001A33",
    cursor: "pointer",
  },
  smallButton: {
    background: "linear-gradient(135deg, #0077CC, #0099FF)",
    borderRadius: 999,
    border: "none",
    padding: "6px 10px",
    fontSize: 12,
    fontWeight: 600,
    color: "#001A33",
    cursor: "pointer",
  },
  row: {
    display: "flex",
    gap: 8,
    marginTop: 8,
    fontSize: 13,
  },
  box: {
    flex: 1,
    background: "rgba(0,30,60,0.8)",
    borderRadius: 8,
    border: "1px solid rgba(0, 155, 255, 0.35)",
    padding: "6px 8px",
  },
  boxLabel: {
    fontSize: 10,
    textTransform: "uppercase",
    opacity: 0.8,
    letterSpacing: "0.05em",
  },
  boxValue: {
    fontSize: 14,
    marginTop: 2,
    fontWeight: 600,
  },
  sectionTitle: {
    fontSize: 14,
    margin: "8px 0 4px",
  },
  miniBox: {
    background: "rgba(0,20,40,0.9)",
    borderRadius: 8,
    border: "1px solid rgba(0, 155, 255, 0.35)",
    padding: 8,
    fontSize: 12,
  },
  miniTitle: {
    fontWeight: 600,
    marginBottom: 2,
  },
  miniText: {
    fontSize: 11,
    marginBottom: 4,
    color: "#A8D5FF",
  },
  miniDone: {
    marginTop: 4,
    fontSize: 11,
    color: "#FFE5A8",
  },
};
